// Portado de src/components/tratamento/CardsIlustrado.astro (site Astro).
import type { ReactNode } from "react";

export interface CardsIlustradoCard {
  img: string;
  titulo: string;
  texto: ReactNode;
}

export interface CardsIlustradoProps {
  sobretitulo: string;
  titulo: string;
  chamada?: ReactNode;
  cards: CardsIlustradoCard[];
}

export function CardsIlustrado({ sobretitulo, titulo, chamada, cards }: CardsIlustradoProps) {
  return (
    <section className="ilustrados">
      <div className="container">
        <p className="sobretitulo">{sobretitulo}</p>
        <h2>{titulo}</h2>
        {chamada && <p className="ilustrados-chamada">{chamada}</p>}
        <ul className="ilustrados-grade">
          {cards.map((c, i) => (
            <li className="ilustrado" key={i}>
              <span className="ilustrado-foto">
                <img
                  src={c.img.replace(/\.(png|jpg|jpeg)$/i, ".webp")}
                  alt={c.titulo}
                  width={420}
                  height={228}
                  loading="lazy"
                />
              </span>
              <div className="ilustrado-texto">
                <h3>{c.titulo}</h3>
                <p>{c.texto}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
